import { ProfileDataProps } from 'components/Shared/MuiTable/Cell/ProfileCell'
import { SocialMediaDataProps } from 'components/Shared/MuiTable/Cell/SocialMediaInfoCell'
import { StringProps } from 'components/Shared/MuiTable/Cell/StringCell'
import { TagCellProps } from 'components/Shared/MuiTable/Cell/TagCell'
import { AmbassadorResponse } from 'services/api/ambassadors'

export interface AmbassadorRowProps {
    favorited: boolean
    profile: ProfileDataProps
    brandUuid: string
    profile_tier: StringProps
    socialMediaInfo: SocialMediaDataProps
    partiposterTags: TagCellProps
    brand_name: string
    brand_task_count: number
    reach?: StringProps
    view?: StringProps
    impression?: StringProps
    engagement_rate?: StringProps
    engagement_sum?: StringProps
    content_engagement_rate?: StringProps
    like?: StringProps
    comment?: StringProps
    share?: StringProps
    save?: StringProps
    tag?: StringProps
    cta_click?: StringProps
    link_click?: StringProps
    sticker_tap?: StringProps
}

export const getAmbassadorRowsDef = (
    data: AmbassadorResponse[],
    ambassadorFavoritedMap: Record<string, boolean>,
): AmbassadorRowProps[] => {
    return data.map(ambassador => {
        const { social_media_accounts: socialMediaAccounts } = ambassador.partiposter_profile

        const isFavorited = ambassadorFavoritedMap[ambassador.partiposter_profile.uuid] ?? true

        return {
            id: crypto.randomUUID(),
            favorited: isFavorited,
            brandUuid: ambassador.brand.uuid,
            profile: {
                profile: {
                    ...ambassador.partiposter_profile,
                },
                hasRequirements: false,
                unmetRequirement: [],
            },
            profile_tier: { value: ambassador.profile_tier },
            socialMediaInfo: {
                profiles: [socialMediaAccounts],
            },
            partiposterTags: {
                profileData: {
                    ...ambassador.partiposter_profile,
                    tags: ambassador.tags,
                    tags_count: ambassador.tags.length,
                },
            },
            brand_name: ambassador.brand.name,
            brand_task_count: ambassador.brand.task_completed_count ?? 0,
            reach: { value: convertToThousandSeparated(ambassador.engagement_stats.reach) },
            view: { value: convertToThousandSeparated(ambassador.engagement_stats.view) },
            impression: { value: convertToThousandSeparated(ambassador.engagement_stats.impression) },
            engagement_rate: { value: convertToPercent(ambassador.engagement_stats.engagement_rate) },
            content_engagement_rate: {
                value: convertToPercent(ambassador.engagement_stats.content_engagement_rate),
            },
            engagement_sum: { value: convertToThousandSeparated(ambassador.engagement_stats.engagement_sum) },
            like: { value: convertToThousandSeparated(ambassador.engagement_stats.like) },
            comment: {
                value: convertToThousandSeparated(ambassador.engagement_stats.comment),
            },
            share: { value: convertToThousandSeparated(ambassador.engagement_stats.share) },
            save: { value: convertToThousandSeparated(ambassador.engagement_stats.save) },
            cta_click: { value: convertToThousandSeparated(ambassador.engagement_stats.cta_click) },
            tag: { value: convertToThousandSeparated(ambassador.engagement_stats.tag) },
            link_click: { value: convertToThousandSeparated(ambassador.engagement_stats.link_click) },
            sticker_tap: { value: convertToThousandSeparated(ambassador.engagement_stats.sticker_tap) },
        }
    })
}

const convertToPercent = (num?: number): string | undefined => {
    if (num === undefined || num === null) return

    return `${new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num)}%`
}

const convertToThousandSeparated = (num?: number): string | undefined => {
    if (!num) return

    return new Intl.NumberFormat().format(num)
}
